import { render, staticRenderFns } from "./Darkbtn.vue?vue&type=template&id=f7b0d080&"
import script from "./Darkbtn.vue?vue&type=script&lang=ts&"
export * from "./Darkbtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports